import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "field-fibrary"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("字段分类")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("字段分类"),
      allowClear: ""
    },
    on: {
      change: function ($event) {
        return _vm.getTemplateSelectOption();
      }
    },
    model: {
      value: _vm.form.field_category,
      callback: function ($$v) {
        _vm.$set(_vm.form, "field_category", $$v);
      },
      expression: "form.field_category"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "all"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全部")) + " ")]), _c("a-select-option", {
    attrs: {
      value: "insurance_template"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("投保模板")) + " ")]), _c("a-select-option", {
    attrs: {
      value: "claims_param"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("理赔参数")) + " ")])], 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("模板类型")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("模板类型"),
      disabled: _vm.form.field_category !== "insurance_template",
      allowClear: ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("字段名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("字段名称"),
      maxLength: 30,
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: function ($event) {
        return _vm.searchField();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1)], 1), _c("div", {
    staticClass: "btn-box"
  }, [_vm.isAuth("home.fieldLibraryStore") ? _c("a-button", {
    staticClass: "new-add-field",
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "addField",
          params: {
            id: -1
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增字段")))]) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record) {
        return [_vm.isShowDictionary(record) ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.addDictionary(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("字典项")))]) : _vm._e(), _vm.isAuth("home.fieldLibraryEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "addField",
                params: {
                  id: record.id
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.fieldLibraryDelete") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.deleteField(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }, {
      key: "field_category",
      fn: function (text, record) {
        return [_vm._v(" " + _vm._s(_vm.$t(_vm.fieldCategoryInfo[text])))];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("add-dirctionary-modal", {
    attrs: {
      visible: _vm.visible,
      dictionaryRecord: _vm.dictionaryRecord
    },
    on: {
      "update:visible": function ($event) {
        _vm.visible = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };